import { i18n } from '@/plugins/i18n'

export const transactionTypes = {
    API: "zero",
    PARDAKHT_SHAKHSI: 1,
    // PAYMAN: 3,
    IVR: 5,
    ALLOTMENT: 8,
    ALLOTMENT_PAYMENT_HELPER: 19,
    ALLOTMENT_DEDICATED: 20,
    DEDICATED: 10,
    COLLECTIVE: 12,
    COLLECTIVE_DEDICATED: 14,
    COLLECTIVE_PAYMENT_HELPER: 16,
    SMS_WALLET_RECHARGE: 18,
    MONEY_REQUEST: 21,
    CARD_TO_CARD: 22,
    OUT_SOURCE: 23,
    // WALLET_RECHARGE: 26,
    // COLLECTIVE_PARDAKHT_SHAKHSI : 28,
    // COLLECTIVE_MONEY_REQUEST  : 29,
    MONEY_REQUEST_BILL: 30,
    COLLECTIVE_ONLINE_FACTOR: 31,
    ONLINE_FACTOR: 32,
    IVR_WALLET_RECHARGE: 33,
    COLLECTIVE_TO_WALLET: 34,
    VIP: 35,
    VIP_WALLET_RECHARGE: 36,
    // COLLECTIVE_TO_WALLET_MONEY_REQUEST: 37,
    COLLECTIVE_TO_WALLET_PARDAKHT_SHAKHSI: 38,
    COLLECTIVE_TO_WALLET_ONLINE_FACTOR: 39,
    MONEY_REQUEST_BILL_TO_WALLET: 40,
    ENAMAD_REGISTER: 41,
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET : 47,
    // COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_MONEY_REQUEST : 48,
    // COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_PARDAKHT_SHAKHSI : 49,
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_ONLINE_FACTOR : 50,
}

export const transactionStr = {
    API: i18n.t('transaction.types.api'),
    // PARDAKHT_SHAKHSI: i18n.t('transaction.types.face'),
    // PAYMAN: i18n.t('transaction.types.payman'),
    IVR: i18n.t('transaction.types.ivr'),
    VIP: i18n.t('transaction.types.vip'),
    ALLOTMENT: i18n.t('transaction.types.allotment'),
    DEDICATED: i18n.t('transaction.types.dedicated'),
    ALLOTMENT_PAYMENT_HELPER: i18n.t('transaction.types.allotment'),
    ALLOTMENT_DEDICATED: i18n.t('transaction.types.allotment'),
    COLLECTIVE: i18n.t('transaction.types.collective'),
    COLLECTIVE_DEDICATED: i18n.t('transaction.types.collective_dedicated'),
    COLLECTIVE_PAYMENT_HELPER: i18n.t('transaction.types.collective_payment_helper'),
    CARD_TO_CARD: i18n.t('transaction.types.card_to_card'),
    SMS_WALLET_RECHARGE: i18n.t('transaction.types.sms_wallet_recharge'),
    // MONEY_REQUEST: i18n.t('transaction.types.money_request'),
    OUT_SOURCE: i18n.t('transaction.types.out_source'),
    // WALLET_RECHARGE: i18n.t('transaction.types.wallet_recharge'),
    // COLLECTIVE_PARDAKHT_SHAKHSI: i18n.t('transaction.types.collective_pardakht_shakhsi'),
    // COLLECTIVE_TO_WALLET_PARDAKHT_SHAKHSI: i18n.t('transaction.types.collective_to_wallet_pardakht_shakhsi'),
    // COLLECTIVE_MONEY_REQUEST: i18n.t('transaction.types.collective_money_request'),
    // COLLECTIVE_TO_WALLET_MONEY_REQUEST: i18n.t('transaction.types.collective_to_wallet_money_request'),
    MONEY_REQUEST_BILL: i18n.t('transaction.types.money_request_bill'),
    ONLINE_FACTOR: i18n.t('transaction.types.online_factor'),
    COLLECTIVE_ONLINE_FACTOR: i18n.t('transaction.types.collective_online_factor'),
    COLLECTIVE_TO_WALLET_ONLINE_FACTOR: i18n.t('transaction.types.collective_to_wallet_online_factor'),
    MONEY_REQUEST_BILL_TO_WALLET: i18n.t('transaction.types.money_request_bill_to_wallet'),
    IVR_WALLET_RECHARGE: i18n.t('transaction.types.ivr_wallet_recharge'),
    VIP_WALLET_RECHARGE: i18n.t('transaction.types.vip_wallet_recharge'),
    COLLECTIVE_TO_WALLET: i18n.t('transaction.types.collective_to_wallet'),
    ENAMAD_REGISTER: i18n.t('transaction.types.enamad_register'),
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET : i18n.t('transaction.types.collection_on_payment_helper_to_wallet'),
    // COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_MONEY_REQUEST : i18n.t('transaction.types.collection_on_payment_helper_to_wallet_money_request'),
    // COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_PARDAKHT_SHAKHSI : i18n.t('transaction.types.collection_on_payment_helper_to_wallet_pardakht_shakhsi'),
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_ONLINE_FACTOR : i18n.t('transaction.types.collection_on_payment_helper_to_wallet_online_factor'),

    get(status) {
        let transaction_str = null;
        Object.keys(transactionTypes).forEach(function (item, index) {
            if(transactionTypes[item] === status) {
                transaction_str = transactionStr[item]
            }
        })

        return transaction_str
    }
}